// Coordonnées et informations de la boulangerie
export const BUSINESS = {
  name: "Au Fournil de Pierre",
  tagline: "Boulangerie artisanale",
  logo: "https://customer-assets.emergentagent.com/job_au-fournil-1/artifacts/xwll9q5p_logo%20pierre.png",
  phoneDisplay: "votre numéro",
  phoneLink: "tel:votrenumero",
  emailDisplay: "votremail@gmail.com",
  emailLink: "mailto:votremail@gmail.com",
  addressLine: "12 rue des Lilas, 44000 Nantes",
  addressStreet: "12 rue des Lilas",
  addressCity: "44000 Nantes",
  mapQuery: "12 rue des Lilas, 44000 Nantes, France",
};

export const MAP_EMBED_SRC =
  "https://www.google.com/maps?q=12+rue+des+Lilas,+44000+Nantes,+France&hl=fr&z=16&output=embed";

export const MAP_DIRECTIONS =
  "https://www.google.com/maps/dir/?api=1&destination=12+rue+des+Lilas,+44000+Nantes,+France";

// Horaires d'ouverture
export const HOURS = [
  { day: "Lundi", value: "Fermé", closed: true },
  { day: "Mardi", value: "6h30 – 19h00" },
  { day: "Mercredi", value: "6h30 – 19h00" },
  { day: "Jeudi", value: "6h30 – 19h00" },
  { day: "Vendredi", value: "6h30 – 19h00" },
  { day: "Samedi", value: "6h30 – 18h00" },
  { day: "Dimanche", value: "7h00 – 13h00" },
];

export const HOURS_NOTE =
  "Il nous arrive de fermer plus tôt lorsque les fournées du jour sont épuisées.";

// Produits
export const PRODUCTS = [
  {
    name: "Baguette de tradition",
    category: "Les pains",
    desc: "Pétrie à la main, pousse lente, croûte fine et mie alvéolée. Cuite tout au long de la journée.",
    image: "https://images.pexels.com/photos/3789032/pexels-photo-3789032.jpeg",
  },
  {
    name: "Pain au levain",
    category: "Les pains",
    desc: "Levain naturel entretenu depuis des années, farine de meule. Une acidité douce et une longue conservation.",
    image: "https://images.pexels.com/photos/27418961/pexels-photo-27418961.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  },
  {
    name: "Pain de campagne",
    category: "Les pains",
    desc: "Un mélange de froment et de seigle, tranché épais. Le compagnon des tablées et des tartines.",
    image: "https://images.pexels.com/photos/11842163/pexels-photo-11842163.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  },
  {
    name: "Croissant au beurre",
    category: "Les viennoiseries",
    desc: "Beurre de Charentes-Poitou AOP, feuilletage à la main. Doré, feuilleté, jamais gras.",
    image: "https://images.unsplash.com/photo-1587912001191-0cd4f14fd89e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Pain au chocolat",
    category: "Les viennoiseries",
    desc: "Deux barres de chocolat noir enroulées dans une pâte levée feuilletée. La gourmandise du matin.",
    image: "https://images.unsplash.com/photo-1623334044303-241021148842?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Viennoiseries du jour",
    category: "Les viennoiseries",
    desc: "Chausson aux pommes, brioche, escargot aux raisins… selon l'inspiration et la saison.",
    image: "https://images.unsplash.com/photo-1530610476181-d83430b64dcd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

// Savoir-faire — chapitres numérotés
export const CHAPTERS = [
  {
    n: "01",
    title: "La farine",
    text: "Nous travaillons des farines de meule issues de blés cultivés près de Nantes. Peu raffinées, elles gardent le goût du grain et nourrissent notre levain.",
    image: "https://images.pexels.com/photos/6280041/pexels-photo-6280041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=800",
  },
  {
    n: "02",
    title: "Le levain",
    text: "Pas de raccourci : notre levain naturel est entretenu chaque jour. Il donne au pain sa mie, son parfum et une conservation qui traverse la semaine.",
    image: "https://images.unsplash.com/photo-1517686469429-8bdb88b9f907?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    n: "03",
    title: "La fournée",
    text: "Le fournil s'allume avant le jour. Chaque pain est façonné à la main puis enfourné à la pierre, jusqu'à cette couleur ambrée qui craque sous les doigts.",
    image: "https://images.pexels.com/photos/9621723/pexels-photo-9621723.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=800",
  },
];

export const HERO_IMAGE = "https://images.pexels.com/photos/10024751/pexels-photo-10024751.jpeg";
export const INTERIOR_IMAGE = "https://images.pexels.com/photos/17156248/pexels-photo-17156248.jpeg";
